import { useNavigate } from "react-router-dom";
import { Search, Plus, BellRing } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { NAV } from "@/constants/testIds";
import { useState } from "react";

export default function TopBar({ onNewReminder, onNewClient }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    if (q.trim()) {
      navigate(`/clienti?q=${encodeURIComponent(q.trim())}`);
    }
  };

  return (
    <header className="h-16 flex-shrink-0 border-b border-stone-200 bg-stone-50/80 backdrop-blur-xl px-6 flex items-center justify-between gap-4">
      <form onSubmit={onSubmit} className="flex-1 max-w-md relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
        <Input
          data-testid={NAV.searchGlobal}
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Cerca cliente per ragione sociale, città, referente…"
          className="pl-9 h-10 bg-white border-stone-200 focus-visible:ring-1 focus-visible:ring-[#F56A1F] focus-visible:border-[#F56A1F]"
        />
      </form>

      <div className="flex items-center gap-2">
        <Button
          data-testid={NAV.newReminderBtn}
          onClick={onNewReminder}
          variant="outline"
          className="h-10 border-stone-200 hover:bg-stone-100 gap-2"
        >
          <BellRing className="w-4 h-4" strokeWidth={1.75} />
          Nuovo Richiamo
        </Button>
        <Button
          data-testid={NAV.newClientBtn}
          onClick={onNewClient}
          className="h-10 bg-[#F56A1F] hover:bg-[#E05206] text-white gap-2 shadow-sm"
        >
          <Plus className="w-4 h-4" strokeWidth={2} />
          Nuovo Cliente
        </Button>
      </div>
    </header>
  );
}
